export default __webpack_public_path__ + "static/Malmgard_MI-0017.png";